import React from "react";
import PropTypes from "prop-types";
import Progress from "reactstrap/lib/Progress";

import { gatherClasses, isFunction, getPercentageValue } from "../../lib/utils";

const renderPercProgress = props => {
  if (props.showPercProgress && props.size !== "sm" && !props.indeterminate) {
    const percentage = getPercentageValue(props.max, props.value);
    return isFunction(props.renderPercProgress)
      ? props.renderPercProgress(props.value, props.max, percentage)
      : `${Math.round(percentage * 100) / 100}%`;
  }

  return null;
};

const LinearProgress = props => {
  const {
    dataTestId,
    label,
    labelPlacement,
    size,
    indeterminate,
    animate,
    max,
    value
  } = props;
  return (
    <div
      data-testid={dataTestId}
      className={gatherClasses(
        props,
        "oui-progress-container",
        label
          ? `oui-labeled-progress oui-labeled-progress-${labelPlacement}`
          : null
      )}
    >
      <Progress
        className={gatherClasses(
          null,
          "oui-linear-progress",
          size,
          indeterminate || animate ? "oui-indeterminate-progress" : null
        )}
        value={indeterminate ? max : value}
        max={max}
      >
        {renderPercProgress(props)}
      </Progress>
      {label && (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label
          className={gatherClasses(
            null,
            "oui-progress-label",
            `oui-progress-label-${labelPlacement}`
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
};

LinearProgress.propTypes = {
  dataTestId: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelPlacement: PropTypes.oneOf(["right", "bottom"]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  indeterminate: PropTypes.bool,
  animate: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

LinearProgress.displayName = "OrionLinearProgress";

export default LinearProgress;
